import { Box, alpha, useTheme } from "@mui/material";

type TrafficLightColor = "success" | "warning" | "error" | "disabled";

interface TrafficLightProps {
  color: TrafficLightColor;
  size?: string;
}

/**
 * Returns the traffic light color based on strike count.
 * 0 = green, 1 = amber, 2+ = red
 */
export const getTrafficLightColor = (
  strikeCount: number | null | undefined
): TrafficLightColor =>
  strikeCount === null || strikeCount === undefined
    ? "disabled"
    : strikeCount === 0
      ? "success"
      : strikeCount === 1
        ? "warning"
        : "error";

/**
 * A subtly glossy traffic light indicator.
 */
export const TrafficLight = ({ color, size = "1.5rem" }: TrafficLightProps) => {
  const theme = useTheme();

  const baseColor = {
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    error: theme.palette.error.main,
    disabled: theme.palette.grey[400],
  }[color];

  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
        borderRadius: "50%",
        background: `radial-gradient(circle at 40% 35%, ${baseColor}, color-mix(in srgb, ${baseColor} 85%, ${theme.palette.common.black}))`,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "15%",
          left: "20%",
          width: "30%",
          height: "25%",
          borderRadius: "50%",
          background: `radial-gradient(ellipse at 50% 50%, ${alpha(theme.palette.common.white, 0.35)}, transparent 70%)`,
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};
